import Swiper from 'swiper'
import { Pagination, Navigation } from 'swiper/modules'

Swiper.use([Navigation, Pagination])

new Swiper('[data-review-swiper]', {
  slidesPerView: 1,
  spaceBetween: 30,
  observer: true,
  pagination: {
    el: '[data-review-progress-bar]',
    type: 'progressbar',
  },
  navigation: {
    prevEl: '[data-review-prev]',
    nextEl: '[data-review-next]',
  },
  breakpoints: {
    1440: {
      spaceBetween: 80,
    },
  },
  on: {
    slideChange: function () {
      const activeIndex = this.activeIndex + 1
      const totalSlides = this.slides.length

      this.slides.forEach((slide, index) => {
        const paginationElement = slide.querySelector('[data-review-pagination]')
        if (paginationElement) {
          paginationElement.textContent =
            index + 1 === activeIndex ? `${activeIndex} / ${totalSlides}` : ''
        }
      })
    },
  },
})
